
import { Document, Page, Text, View, Image, StyleSheet, Font } from "@react-pdf/renderer";
import Collab from '../../Assets/Images/user-logos/collab.png'
import Heart from '../../Assets/Images/user-logos/heart.png'
import Mind from '../../Assets/Images/user-logos/mind.png'
import Perform from '../../Assets/Images/user-logos/perform.png'
import Soul from '../../Assets/Images/user-logos/soul.png'
import Strategy from '../../Assets/Images/user-logos/strategy.png'
import Strength from '../../Assets/Images/user-logos/strength.png'
import vision from '../../Assets/Images/user-logos/vision.png'

const GroupLeadershipItemOverview = () => {

  const styles = StyleSheet.create({
    pagewapper: {
      position: "relative",
      height: "100%"
  },
  page: {
    paddingHorizontal: 21,
    paddingVertical: 30,
    backgroundColor: '#FFFFFF',
    justifyContent: "space-between",
    height: '100%'
  },
  content: {
      // marginTop: "35px",
      display: "flex",
      width: "570px",
      alignItems: "left"
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1px solid #00577D',
    paddingBottom: 5,
    marginBottom: 2,
    marginTop: '-15px'
  },
  titlemain: {
    fontSize: 12,
    fontWeight: 700,
    color: '#76A3BE',
  },
  title: {
    fontSize: 11,
    fontWeight: 200,
    color: '#76A3BE',
  },
  rightsection: {
    alignItems: 'flex-end',
    flexDirection: 'column',
    flex: 1,
  },
  rightText: {
    fontSize: 8,
    textAlign: 'right',
    fontWeight: 700,
    color: '#76A3BE',
  },
  rightTextsybtext: {
    fontSize: 8,
    textAlign: 'right',
    fontWeight: 700,
    color: '#76A3BE',
  },
    contenttitle: {
      fontFamily: "Lato",
      fontWeight: 700,
      fontSize: "18px",
      lineHeight: "30px",
      color: "#426B88"
  },
  headertext: {
    fontFamily: "Lato",
    fontSize: 18,
    fontWeight: 700,
    color: '#426B88',
    marginLeft: 0,
    paddingLeft: 0,
    marginTop: 9.5,
    marginBottom: 9.5,
  },
  paragraph: {
    fontSize: 12,
    textAlign: 'justify',
    fontWeight: 400,
    color: '#245775',
    marginBottom: 5,
    fontFamily: 'Lato',
    lineHeight: '18px',
  },
  wapper: {
      width: "567px",
      fontFamily: "Lato",
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "18px",
      color: "#245775"
    },
    mainContent: {
        marginTop:"14px",
  },
  footer: {
      marginTop: 'auto',
  },
  table: {
      width: '100%',
      // borderWidth: 1,
      // borderColor: '#ccc',
  },
  tableRow: {
      flexDirection: 'row',
      alignItems: 'center',
  },
    tableHeader: {
      paddingVertical: 1,
      fontWeight: 400,
      border:'0px',
      backgroundColor: '#245775',
      fontWeight: 'bold',
      color: 'white',
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
    },
  headerCell:{color: 'white', fontSize: 10.05, fontWeight:400, paddingVertical:"5px"},
  cell: {
      textAlign: "left",
      lineHeight: "12px",
      padding: "3px 3px",
    },
    
    rowEven: {
      backgroundColor: "#F1F3F3",
    },
    rowOdd: {
      backgroundColor: "#FFF",
    },
    footer: {
      width: 540,
      borderTop: '1px solid #00577D',
      paddingTop: 5,
      flexDirection: 'row',
      justifyContent: 'space-between',
      position: 'absolute',
      bottom: 15,
      left: 10,
      right: 21,
    },
    footersection: {
      flexDirection: 'column'
    },
    footerTextheading: {
      fontSize: 10,
      fontWeight: 700,
      fontFamily: 'Lato',
      color: '#76A3BE',
    },
    footerText: {
      fontSize: 8,
      fontFamily: 'Lato',
      fontWeight: 400,
      color: '#76A3BE',
    },
    cellNumber: { width: '5%', textAlign: 'center', fontSize: 8, color:"#394554", fontWeight:400 },
    cellQuadrant: { width: '20%', fontSize: 8, color:"#394554", fontWeight:400 },
    cellQuestion: { width: '60%', fontSize: 8, color:"#394554", fontWeight:400 },
    cellScore: { width: '15%', textAlign: 'center', fontSize: 8, fontWeight: 700 },  
    logoimage : { flexDirection: 'row' },
    logos:  { height: 13.66, width: 13.66, position: 'absolute', right: 5 },
    logoWrapper: {
      flexDirection: 'row',
      alignItems: 'center',
      position: 'relative'
    },
    });

    const data = [
        { "quadrant": "COLLABORATIVE", "img": Collab, "question": "When leading through conflict, I am attuned to the feelings everyone is experiencing.", "score": 4 },
        { "quadrant": "VISIONARY", "img": vision, "question": "My superpower is to rise above any situation to gain a wise perspective.", "score": 4 },
        { "quadrant": "STRATEGIC", "img": Strategy, "question": "When leading through conflict, I follow a specific process to work through it.", "score": 4 },
        { "quadrant": "PERFORMACE", "img": Perform, "question": "My superpower is to rise above any situation to gain a wise perspective.", "score": 4 },
        { "quadrant": "HEART","img": Heart, "question": "When presented with a problem, I am most concerned with how the team is handling it.", "score": 4 },
        { "quadrant": "SOUL","img": Soul, "question": "My superpower is to rise above any situation to gain a wise perspective.", "score": 4 },
        { "quadrant": "MIND","img": Mind, "question": "When presented with a problem, I am most concerned with how the team is handling it.", "score": 4 },
        { "quadrant": "STRENGTH","img": Strength, "question": "My superpower is to rise above any situation to gain a wise perspective.", "score": 4 },
        { "quadrant": "HEART","img": Heart, "question": "When presented with a problem, I am most concerned with how the team is handling it.", "score": 4 },
        { "quadrant": "SOUL","img": Soul, "question": "My superpower is to rise above any situation to gain a wise perspective.", "score": 4 },
        { "quadrant": "MIND","img": Mind, "question": "When presented with a problem, I am most concerned with how the team is handling it.", "score": 4 },
        { "quadrant": "STRENGTH","img": Strength, "question": "My superpower is to rise above any situation to gain a wise perspective.", "score": 4 },
        { "quadrant": "HEART","img": Heart, "question": "When presented with a problem, I am most concerned with how the team is handling it.", "score": 4 },
        { "quadrant": "SOUL","img": Soul, "question": "My superpower is to rise above any situation to gain a wise perspective.", "score": 4 },
        { "quadrant": "MIND","img": Mind, "question": "When presented with a problem, I am most concerned with how the team is handling it.", "score": 4 },
        { "quadrant": "STRENGTH","img": Strength, "question": "My superpower is to rise above any situation to gain a wise perspective.", "score": 4 },
        { "quadrant": "HEART","img": Heart, "question": "When presented with a problem, I am most concerned with how the team is handling it.", "score": 4 },
        { "quadrant": "SOUL","img": Soul, "question": "My superpower is to rise above any situation to gain a wise perspective.", "score": 4 },
        { "quadrant": "MIND","img": Mind, "question": "When presented with a problem, I am most concerned with how the team is handling it.", "score": 4 },
        { "quadrant": "STRENGTH","img": Strength, "question": "My superpower is to rise above any situation to gain a wise perspective.", "score": 4 },
        { "quadrant": "HEART","img": Heart, "question": "When presented with a problem, I am most concerned with how the team is handling it.", "score": 4 },

    ]

    return (
      <View style={styles.page}>
        <View>
          {/* Header */}
          <View style={styles.header}>
            <View style={styles.headerleft}>
              <Text style={styles.titlemain}>QUADRANT FLOW</Text>
              <Text style={styles.title}>Life & Leadership Assssment</Text>
            </View>
            <View style={styles.rightsection}>
              <Text style={styles.rightText}>Rob Murray</Text>
              <Text style={styles.rightTextsybtext}>Atlas Real Estate{"\n"}Oct 18, 2024</Text>
            </View>
          </View>
  
          <View style={styles.container}>
            <View style={styles.containersection}>
              <Text style={styles.headertext}>LEADERSHIP ITEMS GROUP OVERVIEW</Text>
            </View>
          </View> 
  
          {/* Content */}
          <View style={styles.section}>
            <Text style={styles.paragraph}>
              This page presents a ranking of all 40 items distributed across the four leadership scales: Collaborative, Visionary, Strategic, and Performance. The rankings are based on self-ratings provided by participants, using a response scale that ranges from 1 (Least) to 4 (Most).
            </Text>
          </View>
          <View style={styles.mainContent}>
            <View style={styles.tableRow}>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.cell, styles.cellNumber, styles.headerCell]}>#</Text>
                <Text style={[styles.cell, styles.cellQuadrant, styles.headerCell]}>Quadrant</Text>
                <Text style={[styles.cell, styles.cellQuestion, styles.headerCell]}>Question</Text>
                <Text style={[styles.cell, styles.cellScore, styles.headerCell]}>Score</Text>
              </View>
            </View>
            {data.map((item, index) => (
              <View style={[styles.tableRow, index % 2 === 0 ? styles.rowEven : styles.rowOdd]} key={index}>
                <Text style={[styles.cell, styles.cellNumber]}>{index + 1}</Text>
                <View style={[styles.cell, styles.logoWrapper]}>
                  <Text style={[styles.cellQuadrant]}>{item.quadrant}</Text>
                  <Image src={item.img} style={styles.logos} />
                </View>
                <Text style={[styles.cell, styles.cellQuestion]}>{item.question}</Text>
                <Text style={[styles.cell, styles.cellScore]}>{item.score}</Text>
              </View>
            ))}
          </View>
            {/* <Image src={FlowTwo} style={styles.flowimg} /> */}
        </View>
        
        {/* Footer Section */}
        <View style={styles.footer}>
          <View style={styles.footersection}>
            <Text style={styles.footerTextheading}>SELF REPORT</Text>
            <Text style={styles.footerText}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
          </View>
          <Text style={styles.footerTextheading}>PAGE</Text>
        </View>
      </View>
    );
}

export default GroupLeadershipItemOverview;